<div class="rs-form-item">
  <select
    id="ac-selectbox1"
    name="ac-selectbox1"
    class="rs-filled"
    autocompleted=""
    (change)="changeSelectedWebsite($event.target.value)"
  >
    <option *ngFor="let website of websites" [value]="website.accessNumber">
      {{ website.productDescription }}
    </option>
  </select>
  <label class="rs-form-label" for="ac-selectbox1">{{
    'digitalis.manageYourWebsites.selectWebsite.label' | translate
  }}</label>
</div>
